import * as React from 'react'
import { Text } from '@doordash/design-language'
import Button from '@doordash/component-button'
import { SectionContainer, ContentText } from '../../StyleComponents'
import { BikeSafetyCourseCompletionImage } from '../../images'
import { ImageContainer } from '../../styles'
import { i18nKeys } from 'translationTypes'
import i18n from '../../../../../i18n'

interface SafetyCourseCompletionProps {
  onClick?: () => void
  onAnimationEnd?: (status?: string) => void
  buttonState: string
}

export const SafetyCourseCompletion = (props: SafetyCourseCompletionProps) => {
  const { onClick, onAnimationEnd, buttonState } = props

  return (
    <SectionContainer>
      <ImageContainer>
        <BikeSafetyCourseCompletionImage />
      </ImageContainer>
      <Text styles={Text.Styles.Bold32}>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step5__au__heading__safetyCourseCompletion
        )}
      </Text>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step5__au__description1__safetyCourseCompletion
        )}
      </ContentText>
      <Button
        type={Button.Types.PrimaryPill}
        size={Button.Sizes.Large}
        onClick={onClick}
        onAnimationEnd={status => {
          onAnimationEnd(status)
        }}
        state={buttonState}
      >
        {i18n.t(i18nKeys.safetyCourse__completeCourseButton)}
      </Button>
      <ContentText>
        {i18n.t(
          i18nKeys.safetyCourse_bike_step5__au__description2__safetyCourseCompletion
        )}
      </ContentText>
    </SectionContainer>
  )
}
